import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  UserEntersBirthDay,
  userEntersBirthDay,
  UserEntersBirthMonth,
  userEntersBirthMonth,
  userEntersBirthYear,
  UserEntersBirthYear
} from '../actions/Actions';
import { IProductInfo, IState, IUserInfo } from '../CustomTypes';
import { validate16yearOld } from '../validators';
import './BirthDate.scss';

export interface IActionProps {
  userEntersBirthDay: UserEntersBirthDay;
  userEntersBirthMonth: UserEntersBirthMonth;
  userEntersBirthYear: UserEntersBirthYear;
}

export interface IParamProps {
  formSubmitted?: boolean;
}

export interface IStateProps {
  productInfo: IProductInfo;
  userInfo: IUserInfo;
}

export interface IProps extends IParamProps, IStateProps, IActionProps {}

export class BirthDate extends React.Component<
  IProps,
  { showValidationError: boolean }
> {
  private monthInput: HTMLInputElement;
  private yearInput: HTMLInputElement;

  constructor(props: IProps) {
    super(props);
    this.onBlur = this.onBlur.bind(this);
    this.birthDateEntered = this.birthDateEntered.bind(this);
    this.isValid = this.isValid.bind(this);
    this.dayEntered = this.dayEntered.bind(this);
    this.monthEntered = this.monthEntered.bind(this);
    this.state = { showValidationError: false };
  }

  public render() {
    const { birthDay, birthMonth, birthYear } = this.props.userInfo;
    const { formSubmitted } = this.props;

    const validationCorrectClass = this.isValid() ? '  validationCorrect' : '';

    const showValidationError =
      (formSubmitted || this.state.showValidationError) && !this.isValid();
    const validationErrorClass = showValidationError ? ' validationError' : '';

    return (
      <div className="birthDate row">
        <div className={'inputField form-group' + validationErrorClass}>
          <div className="col-xs-4 day">
            <div
              className={`inputField  ${validationCorrectClass} ${validationErrorClass}`}
            >
              <input
                id="input_day"
                type="tel"
                inputMode="numeric"
                pattern="\\d{1,2}"
                title="DD"
                min="1"
                max="31"
                placeholder="DD"
                name="day"
                value={birthDay}
                className="form-control"
                onChange={this.dayEntered}
              />
              <label htmlFor="input_day">
                Din fødselsdato
                {this.isValid() && (
                  <span className="icon ion-checkmark-round" />
                )}
                {showValidationError && (
                  <span className="icon ion-information-circled" />
                )}
              </label>
            </div>
          </div>
          <div className="col-xs-4 month">
            <div className="inputField">
              <input
                ref={input => (this.monthInput = input)}
                type="tel"
                inputMode="numeric"
                pattern="\\d{1,2}"
                title="MM"
                min="1"
                max="12"
                placeholder="MM"
                name="month"
                value={birthMonth}
                className="form-control"
                onChange={this.monthEntered}
              />
            </div>
          </div>
          <div className="col-xs-4 year">
            <div className="inputField">
              <input
                ref={input => (this.yearInput = input)}
                type="tel"
                inputMode="numeric"
                pattern="\\d{4}"
                title="ÅÅÅÅ"
                placeholder="ÅÅÅÅ"
                name="year"
                value={birthYear}
                className="form-control"
                onChange={e =>
                  this.props.userEntersBirthYear(e.currentTarget.value)
                }
                onBlur={this.onBlur}
              />
            </div>
          </div>
        </div>
        {showValidationError && (
          <div className="col-xs-12 validationErrorMessage">
            {!this.birthDateEntered()
              ? 'Vennligst oppgi fødselsdato på formatet DD MM ÅÅÅÅ'
              : null}
          </div>
        )}
        {!showValidationError && (
          <div className="col-xs-12 footnote">
            {this.props.productInfo.pureDigital
              ? 'Er du under 30 år, får du automatisk 50% rabatt'
              : null}
          </div>
        )}
      </div>
    );
  }

  private onBlur() {
    this.setState({ showValidationError: !this.isValid() });
  }

  private isValid(): boolean {
    const { birthDay, birthMonth, birthYear } = this.props.userInfo;
    return (
      this.birthDateEntered() &&
      validate16yearOld(+birthDay, +birthMonth - 1, +birthYear)
    );
  }

  private birthDateEntered(): boolean {
    const { birthDay, birthMonth, birthYear } = this.props.userInfo;
    return !!birthDay && !!birthMonth && !!birthYear && birthYear.length === 4;
  }

  private dayEntered(e: any) {
    const value = e.currentTarget.value;
    this.props.userEntersBirthDay(value);
    if (value && value.length === 2) {
      this.monthInput.focus();
    }
  }

  private monthEntered(e: any) {
    const value = e.currentTarget.value;
    this.props.userEntersBirthMonth(value);
    if (value && value.length === 2) {
      this.yearInput.focus();
    }
  }
}

export default connect(
  (state: IState) =>
    ({
      productInfo: state.productInfo,
      userInfo: state.userInfo
    } as IStateProps),
  dispatch =>
    bindActionCreators(
      {
        userEntersBirthDay,
        userEntersBirthMonth,
        userEntersBirthYear
      },
      dispatch
    ) as IActionProps
)(BirthDate);



// WEBPACK FOOTER //
// ./src/input-components/BirthDate.tsx